import React from "react";
import { AnalyticsWorkspacesResponse } from "../../../api/v2/types";

interface AnalyticsWorkspaceComparisonProps {
  workspaces: AnalyticsWorkspacesResponse | null;
}

const AnalyticsWorkspaceComparison = ({ workspaces }: AnalyticsWorkspaceComparisonProps) => {
  const items = workspaces?.items || [];
  if (!items.length) return <p className="text-sm text-muted-foreground">No workspace comparison data.</p>;

  return (
    <div className="rounded border p-3">
      <p className="mb-2 text-sm font-semibold">Workspace comparison</p>
      <div className="space-y-1">
        {items.map((item) => (
          <div key={item.workspaceKey} className="grid grid-cols-4 gap-2 rounded border p-2 text-xs">
            <span className="font-medium">{item.workspaceKey}</span>
            <span>events: {item.totalEvents}</span>
            <span>fails: {item.failedEvents}</span>
            <span>success: {item.successRate.toFixed(1)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsWorkspaceComparison;
